import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import { getTime, parseISO } from 'date-fns'
import { useTranslation } from 'react-i18next'

import Icon from '../Icons'

import { makePeriods } from './AnalyticsConstants'

const BuildingAnalyticsHeader = ({ selectPeriodHandler, startEndDates }) => {
  const { t } = useTranslation(['building-analytics'])
  const periods = makePeriods(t)
  const defaultPeriod = periods[1]
  const [startDate, endDate] = startEndDates
  // Note: startEndDates is stored as epoch numbers in redux (see
  // buildingAnalyticsReducer initial state), but react-datepicker requires real
  // Date instances for its startDate/endDate props - passing raw numbers makes
  // its internal date math (e.g. .getDate()) blow up on undefined.
  const startDateObj = startDate ? new Date(startDate) : null
  const endDateObj = endDate ? new Date(endDate) : null

  const handleChangeDateFilterValue = ([startDate, endDate]) => {
    selectPeriodHandler({ start: startDate, end: endDate })
  }

  const handleSelectPeriodHandler = (e) => {
    const dates = JSON.parse(e.target.value)
    selectPeriodHandler({
      start: getTime(parseISO(dates.start)),
      end: getTime(parseISO(dates.end)),
    })
  }

  return (
    <div className="building-analytics-header">
      <div className="building-analytics-header__wrapper">
        <div className="building-analytics-header__row">
          <span className="building-analytics-header__text">
            {t('building-analytics:header.dataReports')}
          </span>
          <DatePicker
            className={'input borderless'}
            selectsRange={true}
            startDate={startDateObj}
            endDate={endDateObj}
            maxDate={new Date()}
            placeholderText={t('building-analytics:header.selectDateRangePlaceholder')}
            isClearable={true}
            onChange={handleChangeDateFilterValue}
          />
        </div>
        <div className="building-analytics-header__row">
          <span className="building-analytics-header__text">
            {t('building-analytics:header.selectPeriod')}
          </span>
          <label className="select">
            <select
              id="period"
              name="period"
              defaultValue={JSON.stringify(defaultPeriod.value)}
              className={`select select-input`}
              onChange={handleSelectPeriodHandler}
            >
              {periods.map(({ value, title }) => (
                <option value={JSON.stringify(value)} key={title}>
                  {title}
                </option>
              ))}
            </select>
            <Icon icon="arrow" className="building-analytics-header__select-control" />
          </label>
        </div>
      </div>
      <div className="building-analytics-header__divider" />
    </div>
  )
}

BuildingAnalyticsHeader.propTypes = {
  selectPeriodHandler: PropTypes.func,
  startEndDates: PropTypes.array,
}

export default BuildingAnalyticsHeader
